/* Theme-local Team Hockey Sauce Kit charts: ADULT labels and brand-only artwork.
 * Original product media and all other themes remain unchanged. */
(() => {
  'use strict';
  if (window.hskAdultSizeChartsLoaded) return;
  window.hskAdultSizeChartsLoaded = true;
  const charts = [
    {
      stem: 'Team-Hockey-Sauce-Kit-Jersey-Size-Chart',
      aliases: ['Team-Hockey-Sauce-Kit-Jersey-Size-Chart-ADULT-20261024', 'Team-Hockey-Sauce-Kit-Jersey-Size-Chart_a1ad18c2-6ebe-4990-976b-eab2700d83d1'],
      target: 'Team-Hockey-Sauce-Kit-Jersey-Size-Chart-ADULT-CLEAN-20261024',
      token: '__HSK_CLEAN_JERSEY_CHART__',
      alt: 'Team Hockey Sauce Kit jersey size chart: Youth, ADULT and goalie sizes; measurements in inches.'
    },
    {
      stem: 'Team-Hockey-Sauce-Kit-Sock-Size-Chart',
      aliases: [],
      target: 'Team-Hockey-Sauce-Kit-Sock-Size-Chart-CLEAN-20261024',
      token: '__HSK_CLEAN_SOCK_CHART__',
      alt: 'Team Hockey Sauce Kit hockey sock size chart: XS, S, M, L and XL; measurements in inches.'
    },
    {
      stem: 'Team-Hockey-Sauce-Kit-Pants-Shell-Size-Chart',
      aliases: ['Team-Hockey-Sauce-Kit-Pants-Shell-Size-Chart-ADULT-20261024', 'Team-Hockey-Sauce-Kit-Pants-Shell-Size-Chart_1'],
      target: 'Team-Hockey-Sauce-Kit-Pants-Shell-Size-Chart-ADULT-CLEAN-20261024',
      token: '__HSK_CLEAN_SHELL_CHART__',
      alt: 'Team Hockey Sauce Kit pants shell size chart: Youth, ADULT and goalie sizes; measurements in inches.'
    }
  ];
  const attributes = ['src', 'srcset', 'href', 'data-src', 'data-srcset', 'data-original', 'data-zoom-image', 'style'];
  const selector = 'a,img,source,[data-src],[data-srcset],[data-original],[data-zoom-image],[style],script[data-product-json]';
  const chartTextSelector = '.size-chart,.size-chart__inner,[data-hsk-size-chart]';
  const replaceAll = (value, search, replacement) => value.split(search).join(replacement);
  function rewrite(value) {
    if (typeof value !== 'string') return value;
    for (const chart of charts) {
      if (!value.includes(chart.stem)) continue;
      value = replaceAll(value, chart.target, chart.token);
      for (const alias of chart.aliases) {
        value = replaceAll(value, alias + '.', chart.token + '.');
        value = replaceAll(value, alias + '_', chart.token + '_');
      }
      value = replaceAll(value, chart.stem, chart.token);
      value = replaceAll(value, chart.token, chart.target);
    }
    return value;
  }
  function updateElement(node) {
    for (const attribute of attributes) {
      const before = node.getAttribute(attribute);
      if (!before) continue;
      const after = rewrite(before);
      if (after !== before) node.setAttribute(attribute, after);
    }
    if (node.matches('img')) {
      const source = (node.getAttribute('src') || '') + (node.getAttribute('data-src') || '') + (node.getAttribute('srcset') || '');
      const chart = charts.find(item => source.includes(item.target));
      if (chart && node.alt !== chart.alt) node.alt = chart.alt;
    }
    if (node.matches('script[data-product-json]')) {
      const before = node.textContent;
      const after = rewrite(before);
      if (after !== before) node.textContent = after;
    }
  }
  function updateChartText(root) {
    root.querySelectorAll('a[href*="hypercosports.com"]').forEach(link => {
      link.replaceWith(document.createTextNode(''));
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script,style,textarea')) continue;
      const after = node.nodeValue
        .replace(/\b(?:senior|sr)\b/gi, 'ADULT')
        .replace(/Sizing source:\s*Hyperco(?:\s+Sports)?\.?/gi, '')
        .replace(/Waist and length values shown exactly as published by Hyperco\.?/gi, '')
        .replace(/\bHyperco(?:\s+Sports)?\b/gi, '');
      if (after !== node.nodeValue) node.nodeValue = after;
    }
  }
  function scan(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root.matches?.(selector)) updateElement(root);
    root.querySelectorAll(selector).forEach(updateElement);
    if (root.matches?.(chartTextSelector)) updateChartText(root);
    root.querySelectorAll(chartTextSelector).forEach(updateChartText);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') updateElement(record.target);
      else record.addedNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          const chart = node.parentElement?.closest(chartTextSelector);
          if (chart) updateChartText(chart);
        } else scan(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: attributes });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    if (link) updateElement(link);
  }, true);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
